module.exports = __webpack_public_path__ + "assets/img/index1-old.9898639b.jpg";